import {
  Flex,
  Box,
  FormControl,
  FormLabel,
  Input,
  Checkbox,
  Stack,
  Link,
  Button,
  Heading,
  Text,
  useColorModeValue,
  Avatar,
} from "@chakra-ui/react";
import React from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootStore } from "../../../redux/Store";
import { useHistory } from "react-router-dom";
import { userRegistration } from "../../../redux/actions/user/UserActions";
import { Link as ReachLink } from "react-router-dom";

export default function Register() {
  const [regData, setRegData] = useState<IuserReg>({});

  const [regClickState, setregClickState] = useState(false);
  const errorMsg = "This field must not be empty";
  //---------------------------API integration---------------------------
  const dispatch = useDispatch();
  const userState = useSelector((state: RootStore) => state.user);
  const history = useHistory();
  const handleRegister = () => {
    setregClickState(true);
    if (validation() && namePatternValidation() && emailPatternValidation()) {
      const userData = {
        firstName: regData.firstName,
        lastName: regData.lastName,
        email: regData.email,
        address: regData.address,
        password: regData.password,
        verifyPassword: regData.verifyPassword,
      };
      dispatch(userRegistration(userData, history));
    }
  };

  //-----------------------------------Form validation--------------------------------------
  const validation = (): boolean => {
    let isValid = true;

    if (
      !regData.firstName ||
      !regData.lastName ||
      !regData.email ||
      !regData.address ||
      !regData.password ||
      !regData.verifyPassword
    ) {
      isValid = false;
    }

    return isValid;
  };
  const emailPatternValidation = (): boolean => {
    let isValid = true;
    if (regData.email) {
      var pattern = new RegExp(
        /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
      );
      if (!pattern.test(regData.email)) {
        isValid = false;
      }
    }
    return isValid;
  };
  const namePatternValidation = (name?: string): boolean => {
    let isValid = true;
    if (name) {
      var pattern = new RegExp(/^[A-Za-z]+$/);
      if (!pattern.test(name)) {
        isValid = false;
      }
    }
    return isValid;
  };
  //-------------------------------------------------------------------------

  return (
    <>
      <Flex align={"center"} justify={"center"}>
        <Stack
          spacing={8}
          mx={"auto"}
          maxW={"lg"}
          py={12}
          px={6}
          align="center"
        >
          <Stack align={"center"}>
            <Avatar bg="dodgerblue" size="lg" />
            <Heading fontSize={"4xl"} textAlign="center">
              Create an account
            </Heading>
            {/* <Text fontSize={"lg"} color={"gray.600"}>
              Provide all details
            </Text> */}
          </Stack>
          <Box
            rounded={"md"}
            boxSize="inherit"
            bg={useColorModeValue("gray.50", "gray.800")}
            boxShadow={"md"}
            height="fit-content"
            textAlign="center"
            p={8}
          >
            <Stack spacing={4}>
              {/* <chakra.form> */}
              <FormControl isRequired>
                <FormLabel>First Name</FormLabel>
                <Input
                  isInvalid={
                    regClickState
                      ? !regData.firstName
                        ? true
                        : !namePatternValidation(regData.firstName) && true
                      : false
                  }
                  type="text"
                  id="firstName"
                  background="white"
                  placeholder="First Name"
                  onChange={(event) =>
                    setRegData({ ...regData, firstName: event.target.value })
                  }
                  required
                />
                {regClickState && (
                  <Text fontSize="xs" color="red" marginTop="3px">
                    {!regData.firstName
                      ? errorMsg
                      : !namePatternValidation(regData.firstName) &&
                        "Please enter a valid first name"}
                  </Text>
                )}
              </FormControl>
              <FormControl isRequired>
                <FormLabel>Last Name</FormLabel>
                <Input
                  isInvalid={
                    regClickState
                      ? !regData.lastName
                        ? true
                        : !namePatternValidation(regData.lastName) && true
                      : false
                  }
                  type="text"
                  id="lastName"
                  background="white"
                  placeholder="Last Name"
                  onChange={(event) =>
                    setRegData({ ...regData, lastName: event.target.value })
                  }
                  required
                />
                {regClickState && (
                  <Text fontSize="xs" color="red" marginTop="3px">
                    {!regData.lastName
                      ? errorMsg
                      : !namePatternValidation(regData.lastName) &&
                        "Please enter a valid last name"}
                  </Text>
                )}
              </FormControl>
              <FormControl isRequired>
                <FormLabel>Email Address</FormLabel>
                <Input
                  isInvalid={
                    regClickState
                      ? !regData.email
                        ? true
                        : !emailPatternValidation() && true
                      : false
                  }
                  type="email"
                  id="email"
                  background="white"
                  placeholder="Email Address"
                  onChange={(event) =>
                    setRegData({ ...regData, email: event.target.value })
                  }
                  required
                />
                {regClickState && (
                  <Text fontSize="xs" color="red" marginTop="3px">
                    {!regData.email
                      ? errorMsg
                      : !emailPatternValidation() &&
                        "Please enter a valid email address"}
                  </Text>
                )}
              </FormControl>
              <FormControl isRequired>
                <FormLabel>Address</FormLabel>
                <Input
                  isInvalid={regClickState ? !regData.address && true : false}
                  type="text"
                  id="address"
                  background="white"
                  placeholder="Address"
                  onChange={(event) =>
                    setRegData({ ...regData, address: event.target.value })
                  }
                  required
                />
                {regClickState && !regData.address && (
                  <Text fontSize="xs" color="red" marginTop="3px">
                    {errorMsg}
                  </Text>
                )}
              </FormControl>
              <FormControl isRequired>
                <FormLabel>Password</FormLabel>
                <Input
                  isInvalid={regClickState ? !regData.password && true : false}
                  type="password"
                  id="password"
                  background="white"
                  placeholder="Password"
                  onChange={(event) =>
                    setRegData({ ...regData, password: event.target.value })
                  }
                  required
                />
                {regClickState && !regData.password && (
                  <Text fontSize="xs" color="red" marginTop="3px">
                    {errorMsg}
                  </Text>
                )}
              </FormControl>
              <FormControl isRequired>
                <FormLabel>Verify Password</FormLabel>
                <Input
                  isInvalid={
                    regClickState
                      ? !regData.verifyPassword
                        ? true
                        : regData.password != regData.verifyPassword && true
                      : false
                  }
                  type="password"
                  id="verifyPassword"
                  background="white"
                  placeholder="Verify Password"
                  onChange={(event) =>
                    setRegData({
                      ...regData,
                      verifyPassword: event.target.value,
                    })
                  }
                  required
                />
                {regClickState && (
                  <Text fontSize="xs" color="red" marginTop="3px">
                    {!regData.verifyPassword
                      ? errorMsg
                      : regData.password != regData.verifyPassword &&
                        "Password does not match"}
                  </Text>
                )}
              </FormControl>
              {userState.loginSignUpData?.message && (
                <Text fontSize="xs" color="red" marginTop="3px">
                  {userState.loginSignUpData?.message}
                </Text>
              )}

              <Button
                bg={"#1E1F29"}
                color={"white"}
                _hover={{
                  bg: "blue.500",
                }}
                onClick={handleRegister}
                id="registerButton"
              >
                Register
              </Button>
              {/* </chakra.form> */}

              {/* <Button
                leftIcon={<FaGoogle />}
                colorScheme="google"
                bg={"blue.400"}
                color={"white"}
                _hover={{
                  bg: "blue.500",
                }}
              >
                Continue with Google
              </Button> */}
            </Stack>
            <Text fontSize={"md"} color="#1E1F29" marginBlock="3">
              OR
            </Text>
            <Text marginBlock="3">
              Already have an account ☞{" "}
              <Link
                color={"blue.400"}
                as={ReachLink}
                to="/user-login"
                _focus={{
                  outline: "none",
                  boxShadow: "none",
                  textDecor: "none",
                }}
              >
                Click to Login
              </Link>
            </Text>
          </Box>
        </Stack>
      </Flex>
    </>
  );
}
